import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=af8c104a&scoped=true&"
var script = {}
import style0 from "./Title.vue?vue&type=style&index=0&id=af8c104a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8c104a",
  null
  
)

export default component.exports